/*
  Barra de avisos rolante (sections/cw-marquee-bar.liquid)

  A animação desloca o trilho exatamente a largura de UM grupo de itens por
  volta. Para o último item sempre encontrar o primeiro sem deixar a barra
  vazia, o trilho precisa ter cópias suficientes para cobrir a tela inteira
  mais um grupo. Este script mede o grupo e a barra, ajusta a quantidade de
  cópias e informa ao CSS a distância exata a percorrer. Recalcula quando a
  janela muda de tamanho ou quando imagens/fontes carregam e mudam a largura.
*/
if (!customElements.get('cw-marquee-bar')) {
  class CwMarqueeBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cw-marquee__track');
      this.source = this.track && this.track.querySelector('.cw-marquee__group');
      if (!this.source) return;

      this.lastDistance = 0;
      this.scheduleUpdate = this.scheduleUpdate.bind(this);
      this.update = this.update.bind(this);

      this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.source);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.scheduleUpdate);
      }

      this.scheduleUpdate();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      cancelAnimationFrame(this.frame);
    }

    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(this.update);
    }

    update() {
      const groupWidth = this.source.getBoundingClientRect().width;
      const barWidth = this.getBoundingClientRect().width;
      if (!groupWidth || !barWidth) return;

      // Cópias para cobrir a barra inteira + 1 grupo que "entra" enquanto o
      // primeiro sai. Mínimo de 2, que é o que já vem no HTML.
      const needed = Math.max(2, Math.ceil(barWidth / groupWidth) + 1);
      const groups = this.track.querySelectorAll('.cw-marquee__group');

      if (groups.length !== needed) {
        groups.forEach((group, index) => {
          if (index > 0) group.remove();
        });
        for (let i = 1; i < needed; i++) {
          this.track.appendChild(this.createClone());
        }
      }

      if (Math.abs(groupWidth - this.lastDistance) > 0.5) {
        this.lastDistance = groupWidth;
        this.style.setProperty('--cw-mq-distance', `${groupWidth}px`);
        this.restartAnimation();
      }
    }

    // Cópia só visual: invisível para leitores de tela, fora da navegação
    // por teclado e sem os atributos que o editor de tema usa para
    // identificar blocos (senão o editor destacaria a cópia errada).
    createClone() {
      const clone = this.source.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
      clone.querySelectorAll('img').forEach((img) => img.setAttribute('alt', ''));
      return clone;
    }

    // Alguns navegadores (Safari) não recalculam uma variável CSS usada dentro
    // de @keyframes com a animação em andamento; reiniciar força a leitura.
    restartAnimation() {
      this.track.style.animation = 'none';
      void this.track.offsetWidth;
      this.track.style.animation = '';
    }
  }

  customElements.define('cw-marquee-bar', CwMarqueeBar);

  // No editor de tema: pausa a barra enquanto um aviso está selecionado, para
  // dar para ver e editar o bloco sem ele sair rolando da tela.
  document.addEventListener('shopify:block:select', (event) => {
    const bar = event.target.closest('cw-marquee-bar');
    if (bar) bar.classList.add('is-paused');
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const bar = event.target.closest('cw-marquee-bar');
    if (bar) bar.classList.remove('is-paused');
  });
}
